/**
 * 検証テンプレ targetField の候補定義 (Admin Wave AW4、docs/108 High #8)。
 *
 * 旧 `old2/apps/admin/src/pages/VerificationTemplateEditorPage.tsx` の
 * `PER_POST_FIELDS` / `PER_CLS_FIELDS` を v2 に踏襲。QuestionListEditor の targetField を
 * フリーテキスト劣化から datalist 候補 (任意入力も可) に戻すために使う。
 *
 * old2 との差分:
 *   - old2 は `<select>` で固定選択肢のみだった。v2 では「将来 fields[] 駆動の列名動的化に対応する」
 *     方針 (MEMORY old2 fields移植目標 レベル3) に合わせ、`<input list>` (datalist) として
 *     「候補を出しつつ任意入力も許す」中間形に統一。表示は old2 と同じ日本語ラベル。
 */

export interface VerificationFieldOption {
  /** targetField に保存する値。null は「特定フィールドなし (全体について)」。 */
  value: string | null;
  label: string;
}

/** perPost 質問の対象 AI フィールド候補 (old2 PER_POST_FIELDS 踏襲)。 */
export const PER_POST_FIELDS: VerificationFieldOption[] = [
  { value: null, label: '— なし（投稿全体について）' },
  { value: 'description', label: 'description (画像の説明)' },
  { value: 'professional_insight', label: 'professional_insight (専門家の一言)' },
  { value: 'reasoning', label: 'reasoning (推論プロセス)' },
  { value: 'positive_score', label: 'positive_score' },
  { value: 'negative_score', label: 'negative_score' },
  // ECW 固有フィールド
  { value: 'emotionText', label: 'emotionText (撮影者の心情) ※ECW' },
  { value: 'emotions', label: 'emotions (感情ラベル) ※ECW' },
  { value: 'emotionReason', label: 'emotionReason (感情の根拠) ※ECW' },
  { value: 'categoryCodes', label: 'categoryCodes (対象分類) ※ECW' },
  { value: 'categoryReason', label: 'categoryReason (分類理由) ※ECW' },
];

/** perClassification 質問の対象 AI フィールド候補 (old2 PER_CLS_FIELDS 踏襲)。 */
export const PER_CLS_FIELDS: VerificationFieldOption[] = [
  { value: null, label: '— なし（分類行全体について）' },
  { value: 'category', label: 'category (カテゴリ)' },
  { value: 'hzr', label: 'hzr (災害種別)' },
  { value: 'assessment', label: 'assessment (評価)' },
  { value: 'assessment_level', label: 'assessment_level (大/中/小)' },
  { value: 'score', label: 'score (スコア)' },
  { value: 'comment', label: 'comment (コメント)' },
];

/** scope ごとの候補を返す。 */
export function fieldOptionsForScope(
  scope: 'perPost' | 'perClassification',
): VerificationFieldOption[] {
  return scope === 'perPost' ? PER_POST_FIELDS : PER_CLS_FIELDS;
}
